import { SxProps, Theme } from '@mui/material';

const FADE_TRANSITION_DURATION = '500ms';

export const contentContainerSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	maxWidth: 'xl',
	mx: 'auto',
	bgcolor: 'background.paper',
};

export const mainDisplayContainerSX: SxProps<Theme> = () => ({
	position: 'relative',
	overflow: 'hidden',
	transition: `opacity ${FADE_TRANSITION_DURATION} ease-in-out`,
	width: '100%',
	padding: '50% 0 25% 0',
	'&.is-fading': {
		opacity: 0,
	},
	'& .swiper': {
		position: 'absolute',
		inset: 0,
		width: '100%',
		height: '100%',
	},
	'& .swiper-slide': {
		position: 'relative',
		width: '100%',
		height: '100%',
	},
});

export const thumbnailGalleryWrapperSX: SxProps<Theme> = {
	width: '100%',
	mt: 3,
	'& .swiper-slide': { width: '142px', outline: 'none' },
	'& .swiper': { width: '100%', overflow: 'hidden' },
	'& .swiper-wrapper': { alignItems: 'flex-start' },
};

export const noVideoMsgContainerSX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	height: 160,
	bgcolor: 'grey.100',
	borderRadius: '8px',
	maxWidth: 'xl',
	mx: 'auto',
	p: 4,
	fontFamily: 'sans-serif',
};

export const playerWrapperSX: SxProps<Theme> = () => ({
	width: '100%',
	display: 'flex',
});

export const iframeContainerSX: SxProps<Theme> = () => ({
	width: '100%',
	height: '100%',
	boxSizing: 'border-box',
	px: '20px',
	bgcolor: 'common.black',
});

export const mainImageOverlaySX = {
	position: 'absolute',
	inset: 0,
	cursor: 'pointer',
	'&:hover .thumbnail-image': {
		transform: 'scale(1.03)',
	},
	'&:hover .play-overlay': {
		bgcolor: 'rgba(0,0,0,0.6)',
	},
	'&:hover .play-button': {
		opacity: 1,
		transform: 'scale(1.1)',
	},
};

export const mainImageSX = {
	position: 'absolute',
	inset: 0,
	width: '100%',
	height: 'auto',
	objectFit: 'cover',
	transition: 'transform 500ms ease-in-out',
};

export const playOverlaySX: SxProps<Theme> = (theme) => ({
	position: 'absolute',
	inset: 0,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	transition: 'background-color 300ms ease-in-out',
	border: '2px solid #ccc',
	'&:hover': {
		borderColor: `${theme.palette.grey[500]}`,
	},
});
export const playOverlaySelectedSX: SxProps<Theme> = (theme) => ({
	position: 'absolute',
	inset: 0,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	transition: 'background-color 300ms ease-in-out',
	height: '100%',
});

export const thumbnailContainerSX = {
	position: 'relative',
	height: '80px',
	width: '142px',
	cursor: 'pointer',
};

export const thumbnailSelectedContainerSX: SxProps<Theme> = (theme) => ({
	position: 'relative',
	height: '85px',
	width: '142px',
	cursor: 'pointer',
	boxSizing: 'border-box',
	borderBottom: '2px solid',
	borderColor: theme.palette.grey[500],
	display: 'block',
});

export const thumbnailImgSX = {
	inset: 0,
	width: '142px',
	height: '80px',
	objectFit: 'cover',
};

export const thumbnailSelectedImgSX: SxProps<Theme> = (theme) => ({
	inset: 0,
	width: '142px',
	height: '80px',
	objectFit: 'cover',
	border: `2px solid ${theme.palette.grey[500]}`,
	borderRadius: '3px',
});

export const iframeStyle = {
	display: 'block' as const,
	width: '100%',
	height: '100%',
	borderTop: '50px solid #000',
	borderBottom: '50px solid #000',
};

export const dotsVideoGallerySX = (isActive: boolean): SxProps<Theme> => ({
	cursor: 'pointer',
	transition: 'all 0.3s ease-in-out',
	opacity: isActive ? 0.8 : 1,
	width: isActive ? '35px' : '8px',
	height: '8px',
	borderRadius: isActive ? '4px' : '50%',
	bgcolor: isActive ? 'grey.500' : 'grey.100',
});
